import(/* webpackMode: "eager" */ "/app/apps/tiny-url/src/app/[tinyURL]/page.tsx");
